import { Icon } from '@dynamic/ui';
import styled from 'styled-components';

import { Button as BaseButton } from '#/components/Button/Button';
import { hoverOpacity } from '#/components/styles';
import { remify } from '#/service/utils';

export const Container = styled.div`
  margin: ${remify(80)} ${remify(50)} 0;
`;

export const Title = styled.h1`
  text-align: center;
  font: var(--fontStyleTitle1);
  color: var(--pageHeadingForeground);
  margin: 0;
`;

export const Description = styled.p`
  text-align: center;
  font: var(--fontStyleSubtitle);
  color: var(--pageParagraphForeground);
  margin: ${remify(8)} 0 0;
`;

export const CardContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${remify(16)};
  margin-top: ${remify(48)};
  justify-content: center;
`;

export const ButtonContainer = styled.div`
  display: grid;
  gap: ${remify(8)};
  margin-block: ${remify(48)};
`;

export const Button = styled(BaseButton)`
  width: min(${remify(450)}, 100%);
  height: ${remify(48)};
  border-radius: ${remify(5)};
  justify-content: center;
  justify-self: center;
`;

export const Card = styled.label`
  width: ${remify(250)};
  height: ${remify(341)};
  padding: ${remify(24)};
  border-radius: ${remify(5)};
  background-color: var(--pageSecondaryBackground);
  display: inline-block;
  position: relative;
  cursor: pointer;

  ${hoverOpacity}
`;

export const CardInput = styled.input`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  cursor: pointer;
  margin: 0;
`;

export const CardImageContainer = styled.div`
  position: relative;
  width: 100%;
  box-sizing: border-box;
`;

export const CardImage = styled.img<{ $selected: boolean }>`
  width: 100%;
  aspect-ratio: 1;
  border-radius: 0.2rem;
  opacity: ${({ $selected }) => ($selected ? 0.5 : 1)};
`;

export const CardCheckmarkIcon = styled(Icon)<{ $selected: boolean }>`
  position: absolute;
  width: 50%;
  height: 50%;
  top: 25%;
  left: 25%;
  opacity: ${({ $selected }) => ($selected ? 1 : 0)};
  scale: 1;
  transition-property: opacity, scale;
  transition-duration: 250ms;
  transition-timing-function: ease-in;
  transform-origin: center;
  filter: drop-shadow(0 0 0.5rem #0008);
`;

export const CardText = styled.p`
  text-align: center;
  font: var(--fontStyleCallout);
  color: var(--pageParagraphForeground);
  margin-top: ${remify(16)};
  max-height: ${remify(48)};
`;
